import { configureStore } from "@reduxjs/toolkit";
import { asnReducer } from "./asn.slice";
import { alertReducer } from "./alert.slice";
import { authReducer } from "./auth.slice";
import { usersReducer } from "./users.slice";
import { poheadersReducer } from "./poheader.slice";
import { rtvReducer } from "./rtv.slice";
import { scheduleReducer } from "./schedule.slice";
import { verficationReducer } from "./verfication.slice";
import { invoiceReducer } from "./invoice.slice";
import { pdfDownloadReducer } from "./pdfdownload.slice";
import { pickupReducer } from "./schedulePickup.slice";
import { docenterReducer } from "./doCenter.slice";
import { filterReducer } from "./filter.slice"

export * from "./alert.slice";
export * from "./auth.slice";
export * from "./users.slice";
export * from "./poheader.slice";
export * from "./rtv.slice";
export * from "./schedule.slice";
export * from "./verfication.slice";
export * from "./asn.slice";
export * from "./invoice.slice";
export * from "./pdfdownload.slice";
export * from "./schedulePickup.slice";
export * from "./doCenter.slice";
export * from "./filter.slice";

export const store = configureStore({
  reducer: {
    alert: alertReducer,
    auth: authReducer,
    users: usersReducer,
    poheaders: poheadersReducer,
    rtv: rtvReducer,
    schedule: scheduleReducer,
    verfication: verficationReducer,
    asn: asnReducer,
    invoice: invoiceReducer,
    pdfDownload: pdfDownloadReducer,
    pickupSchedule: pickupReducer,
    document: docenterReducer,
    filter: filterReducer
  },
  devTools: process.env.NODE_ENV !== "production",
});
